<template>
  <div>
    <van-popup round style="width: 80%" v-model="showTag" @closed="onClosed">
      <div class="flex column main">
        <div class="flex1 flex column overflow-hidden">
          <v-tabs :data="tabs" class="flex0" @change="onChange" ref="tabs"></v-tabs>
          <div class="flex1 overflow-y-auto pl15 pr15 pt10 pb10" v-if="currTab==='检查'">
            <p v-for="(item,index) in jcList" :key="index">
              项目名称：{{ item.jIANCHAXMMC }}<br/>
              预约时间：{{ item.yUYUESQSJ }}<br/>
              检查院区：{{ item.fYBH }}{{ item.jIFANGH }} <br/><br/>
              <span class="color_999">检查注意事项：{{ item.nOTICE }}</span>
            </p>
            <no-data v-if="jcList.length===0" text="暂无检查数据"></no-data>
          </div>
          <div class="flex1 overflow-y-auto pl15 pr15 pt10 pb10" v-if="currTab==='检验'">
            <p v-for="(item,index) in jyList" :key="index">
              项目名称：{{ item.dYMC }}<br/>
              预约时间：{{ item.kDRQ }}<br/>
              检验院区：{{ item.fYBH }}
            </p>
            <no-data v-if="jyList.length===0" text="暂无检验数据"></no-data>
          </div>
        </div>
        <div class="footer flex0 pl30 pr30 pb15 pt15">
          <van-button type="info" class="mb10" block round @click="onClick('confirm')">
            我知道了
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import VTabs from "@/plugins/v-tabs";
import NoData from "@/plugins/no-data";

export default {
  name: "confirm",
  components: {NoData, VTabs},
  data() {
    return {
      currTab: '检查',
      tabs: [{label: '检查'}, {label: '检验'}],
      title: "",
      active: 0,
      message: "",
      icon: '',
      jyList: [],
      jcList: [],
      confirmBtnText: "我知道了",
      showTag: false
    }
  },
  methods: {
    open() {
      this.showTag = true;
      this.$nextTick(() => {
        let curr = 0
        if (this.jcList.length === 0) {
          curr = 1;
        }
        if (this.jyList.length === 0) {
          curr = -1;
        }

        this.$refs.tabs.setCurr(curr);
      })
    },
    close() {
      this.showTag = false;
    },
    onClosed() {
      if (this.remove) this.remove(this.type);
    },
    onClick(type) {
      this.type = type;
      this.close()
    },
    onChange(data) {
      // Log('data111111111111', data);
      this.currTab = data.label;

    }
  },
}
</script>

<style scoped lang="scss">
p + p {
  margin-top: 20px;
}

.main {
  max-height: 70vh;
}
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/ds-jcjy.vue